import React from "react";

/**
 * TextInput Component
 *
 * Reusable text input field with label and consistent styling.
 *
 * @param {string} label - Label text to display above the input
 * @param {string} value - Current input value
 * @param {function} onChange - Handler for value changes
 * @param {string} placeholder - Placeholder text
 * @param {string} type - Input type (default: "text")
 */
const TextInput = ({
  label,
  value,
  onChange,
  placeholder = "",
  type = "text",
}) => {
  return (
    <div>
      {label && (
        <label
          style={{
            display: "block",
            fontSize: "14px",
            fontWeight: "500",
            color: "#525252",
            marginBottom: "8px",
          }}
        >
          {label}
        </label>
      )}
      <input
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        style={{
          width: "100%",
          padding: "12px 16px",
          fontSize: "15px",
          color: "#1a1a1a",
          backgroundColor: "#fff",
          border: "1px solid #e5e5e5",
          borderRadius: "8px",
          outline: "none",
          transition: "border-color 0.2s ease",
          boxSizing: "border-box",
        }}
        onFocus={(e) => (e.currentTarget.style.borderColor = "#a3a3a3")}
        onBlur={(e) => (e.currentTarget.style.borderColor = "#e5e5e5")}
      />
    </div>
  );
};

export default TextInput;
